import { Component } from "@angular/core";
import { ChildrenOutletContexts, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LocalizationService } from "src/app/services/localization.service";

import { fadeAnimation } from "./animations/fade-animation";
import RouteNameConstants from "./constants/route-name-constants";
import { AppInsightsService } from "./services/app-insight.service";
import { AuthService } from "./services/auth.service";
import { BrandingService } from "./services/branding.service";
import { CompanyService } from "./services/company.service";
import { MatIconService } from "./services/mat-icon.service";
import { RegionService } from "./services/region.service";
import { isBlockedBySalesforceMigration } from "./utils/company.utils";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [fadeAnimation],
  standalone: false,
})
export class AppComponent {
  title = "WhereIsMyTool";

  constructor(
    public authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private localization: LocalizationService,
    private contexts: ChildrenOutletContexts,
    private matIconService: MatIconService, // DON'T delete, we need it for initialization
    private companyService: CompanyService,
    private brandingService: BrandingService, // DON'T delete, we need it for initializing correct CSS variables based on brand
    private regionService: RegionService, // Don't delete, added to initialize the regionService to set the region value from localStorage //private errorHandler: AppErrorHandler
    private appInsightService: AppInsightsService,
  ) {}

  get translationReady() {
    return this.translate.currentLang;
  }

  getRouteAnimationData(): string {
    return this.contexts.getContext("primary")?.route?.snapshot?.data?.[
      RouteNameConstants.ROUTE_NAME_DATA_PROP
    ];
  }

  show() {
    return (
      this.authService.isUserProfileSet ||
      this.router.url.startsWith(RouteNameConstants.LOGIN) ||
      this.router.url.startsWith(RouteNameConstants.REQUEST_ACCOUNT)
    );
  }

  /** External users of customers migrated to Salesforce only see the migration notice. */
  public get isBlockedBySalesforceMigration(): boolean {
    return isBlockedBySalesforceMigration(
      this.authService.user,
      this.companyService.selectedCompany,
    );
  }

  public get isLoggedInAndCompanySelected() {
    return this.authService.isLoggedIn && this.companyService.selectedCompany;
  }
}
